import React from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router'
import { selectCurrentUser } from '../redux/modules/selectors'
import { selectQuery } from '../redux/selectors/routerSelectors'
import { rootRoute, registerRoute } from '../routes/routes'

const PageTeamInvite = ({ inviteCode, currentUser, isCurrentUserLoading }) => {
  if (!inviteCode) {
    return <Redirect to={rootRoute.path} />
  }

  if (!currentUser && !isCurrentUserLoading) {
    return <Redirect to={`${registerRoute.path}?teamInviteCode=${inviteCode}`} />
  }

  if (currentUser && !isCurrentUserLoading) {
    return <Redirect to={`${rootRoute.path}?teamInviteCode=${inviteCode}`} />
  }

  return null
}

const mapStateToProps = state => {
  const { inviteCode } = selectQuery(state)
  const currentUser = selectCurrentUser(state)
  const { isCurrentUserLoading } = state.user

  return {
    inviteCode,
    currentUser,
    isCurrentUserLoading,
  }
}

export default connect(mapStateToProps)(PageTeamInvite)
